import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_DiseaseProfile = {
    _v1: {
        deleteChiefComplaint: { method: HttpMethod.POST, path: '/v1/disease-profile/delete-chief-complaint' },
        export: { method: HttpMethod.GET, path: '/v1/disease-profile/export' },
        import: { method: HttpMethod.POST, path: '/v1/disease-profile/import' },
        deleteWholeDiseaseProfile: { method: HttpMethod.POST, path: '/v1/disease-profile/delete-whole-disease-profile' },
        deleteReference: { method: HttpMethod.POST, path: '/v1/disease-profile/delete-reference' },
    }
};
export const ApiDef_DiseaseProfileHtml = {
    _v1: {
        setDiseaseProfileHtml: { method: HttpMethod.POST, path: '/v1/disease-profile/set-html', timeout: Minute * 5 },
        removeDiseaseProfileHtml: { method: HttpMethod.POST, path: '/v1/disease-profile/remove-html', timeout: Minute },
    }
};
//# sourceMappingURL=api-def.js.map